import { Modal } from "bootstrap";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { toast } from "react-toastify";

export const AwbPopup = forwardRef((props, ref) => {
  const { awbList = [] } = props;

  const modalRef = useRef(null);
  const bsModal = useRef(null);

  useImperativeHandle(ref, () => ({
    open() {
      if (!bsModal.current) {
        bsModal.current = new Modal(modalRef.current);
      }
      bsModal.current.show();
    },

    close() {
      bsModal.current?.hide();
    },
  }));

  const handleClose = () => {
    bsModal.current?.hide();
  };

  const getAwbNumber = (awb) => {
    if (typeof awb === "string" || typeof awb === "number") {
      return awb;
    }

    return awb?.awbNumber || awb?.awbNo || awb?.number || "-";
  };

  const handleCopyAllAwb = async () => {
    try {
      const allAwbNumbers = awbList
        .map((awb) => getAwbNumber(awb))
        .filter((awb) => awb && awb !== "-")
        .join(", ");

      await navigator.clipboard.writeText(allAwbNumbers);

      // toast.success("All AWB numbers copied successfully!");
    } catch (error) {
      console.error("AWB copy error:", error);
      toast.error("Unable to copy AWB numbers");
    }
  };

  return (
    <div
      className="modal fade"
      ref={modalRef}
      tabIndex="-1"
      aria-hidden="true"
      style={{
        background: "rgba(15,23,42,0.55)",
        backdropFilter: "blur(5px)",
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content border-0 rounded-4 shadow">
          {/* HEADER */}
          <div
            className="modal-header border-0 text-white rounded-top-4"
            style={{
              background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
            }}
          >
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <p className="mb-0 small opacity-75">
                Total AWBs: {awbList.length}
              </p>
            </div>

            <button
              type="button"
              className="btn btn-light rounded-circle"
              style={{ width: "38px", height: "38px" }}
              onClick={handleClose}
              aria-label="Close"
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body p-4">
            {awbList.length === 0 ? (
              <div className="text-center text-muted py-4">
                No AWB available
              </div>
            ) : (
              <div className="border rounded-3 p-3 bg-light">
                <div className="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                  {/* ALL AWB NUMBERS */}
                  <div
                    className="fw-semibold text-break flex-grow-1"
                    style={{
                      lineHeight: "1.8",
                      userSelect: "text",
                    }}
                  >
                    {awbList
                      .map((awb) => getAwbNumber(awb))
                      .filter((awb) => awb && awb !== "-")
                      .join(", ")}
                  </div>

                  {/* COPY ALL BUTTON */}
                  <button
                    type="button"
                    className="btn btn-light btn-sm rounded-pill px-3 flex-shrink-0"
                    onClick={handleCopyAllAwb}
                    disabled={awbList.length === 0}
                  >
                    <i className="fas fa-copy me-2"></i>
                    Copy All
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className="modal-footer border-0 px-4 pb-4">
            <button
              type="button"
              className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});
